import { mapFormValuesToPrinter, mapPrinterToFormValues } from './utils/form-data-transforms'
import PrinterConfiguration from '@/features/settings/components/PrinterConfiguration'
import { Form } from '@/features/settings/components/PrinterConfiguration/form/types'
import { EditPrinterPageParams } from '@/features/settings/pages/EditPrinterPage/types'
import { useAppDispatch, useAppSelector } from '@/hooks/redux'
import { updatePrinter } from '@/redux/reducers/printers'
import { printersSelectors } from '@/redux/reducers/printers/selectors'
import { useLocalSearchParams, useRouter } from 'expo-router'
import { FC, useEffect } from 'react'

const EditPrinterPage: FC = () => {
    const { id } = useLocalSearchParams<EditPrinterPageParams>()
    const router = useRouter()

    const dispatch = useAppDispatch()
    const printer = useAppSelector(printersSelectors.printerById(id))

    useEffect(() => {
        if (printer) return

        router.dismissTo('/settings/printers')
    }, [printer, router])

    const handleBack = () => {
        router.dismissTo('/settings/printers')
    }

    const handleFormSubmit = async (form: Form) => {
        if (!printer) return

        const updatedPrinter = mapFormValuesToPrinter(form, printer)
        await dispatch(updatePrinter(updatedPrinter))

        router.dismissTo('/settings/printers')
    }

    if (!printer) {
        return null
    }

    return (
        <PrinterConfiguration
            initialFormValues={mapPrinterToFormValues(printer)}
            connectionOptions={printer.connectionOptions}
            onBack={handleBack}
            onFormSubmit={handleFormSubmit}
        />
    )
}

export default EditPrinterPage
